module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/PinusPumila/Nagano_PinusPumila_HadGEM2_RCP85_Now.png";